<template>
	<el-dialog :visible.sync="showuserlist" title="选择人员" width="800px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="true">
		<userlist style="overflow-y:auto;height:410px;" :gridh="gridh" pagety="select" ref="userlist"></userlist>
		<div style="text-align: center;width:100%;padding-top:0px">
			<el-button size="mini" type="success" @click.native="selectsure">确定</el-button>
			<el-button size="mini" type="info" plain @click.native="showuserlist = false">取消</el-button>
		</div>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
import userlist from '@/pages/user/index.vue';
export default {
	components: {
		userlist
	},
	props: {},
	data() {
		return {
			showuserlist: false,
			checkrow: [],
			gridh:'320px'
		};
	},
	mounted() {},
	methods: {
		init() {
			this.showuserlist = true;
		},
		//选择确认
		selectsure() {
			//debugger
			var searchinfo=this.$refs.userlist.GetCheckedOrder(false);
			if(searchinfo!=''){
				var paraminfo = {
					search: searchinfo,
					mode: this.$refs.userlist.mode,
					tab: this.$refs.userlist.activeName,
					sort: this.$refs.userlist.sort,
					userid: localStorage.getItem('userid')
				};
				this.$emit('selectusersure', {
					paraminfo:paraminfo
				});
			}else{
				this.$tool.message('请勾选用户', 2);
			}
		}
	}
};
</script>
<style></style>
